import React, { Component } from "react";

import PropTypes from "prop-types";
//import axios from "axios";

export class HeroItem extends Component {
  state = {
    imgUrl: "",
    imgUrlTh: "",
    imgUrlMd: "",
    imgUrlLg: "",
    imgUrlMdLg: "",
    imgUrl600: "",
    imgUrl900: "",
    imgUrl2000: ""
  };
  static propTypes = {
    hero: PropTypes.object.isRequired,
  };

  

  render() {
      //@ts-ignore
    const { slug, title, content, acf } = this.props.hero;
    //const { imgUrl } = this.state;
    
      return (
        <section id={slug} className="ob-hero">

          <div className="text-container">
            <div>
              <div dangerouslySetInnerHTML={{ __html: content.rendered }}></div>
              <div className="around-button"><span className="myButton"><a className="button" href={acf.button_link}>{acf.button_text}</a></span></div>
            </div>
          </div>
          
          <div className="hero-img-fix">
            <img src="https://obrien365.com/ob-wp/wp-content/uploads/2020/11/2021-OBrien-Revival-Wakesurfer-Hero-2.jpg" srcSet="https://obrien365.com/ob-wp/wp-content/uploads/2020/11/2021-OBrien-Revival-Wakesurfer-Hero-2-300x200.jpg 300w, https://obrien365.com/ob-wp/wp-content/uploads/2020/11/2021-OBrien-Revival-Wakesurfer-Hero-2-1024x683.jpg 1024w, https://obrien365.com/ob-wp/wp-content/uploads/2020/11/2021-OBrien-Revival-Wakesurfer-Hero-2-768x512.jpg 768w, https://obrien365.com/ob-wp/wp-content/uploads/2020/11/2021-OBrien-Revival-Wakesurfer-Hero-2-630x420.jpg 630w, https://obrien365.com/ob-wp/wp-content/uploads/2020/11/2021-OBrien-Revival-Wakesurfer-Hero-2-960x640.jpg 960w, https://obrien365.com/ob-wp/wp-content/uploads/2020/11/2021-OBrien-Revival-Wakesurfer-Hero-2-2048x1366.jpg 2048w" alt={title.rendered} />
            <div className="overlay"></div>
          </div>
          
        </section>
      );
    
  }
}

export default HeroItem;
